import { AlertBanner, AlertBannerButton, AlertBannerText } from "monday-ui-react-core";

interface Props {
  text: string;
  isCloseHidden?: boolean;
  onClose?: VoidFunction;
}

export default function BuyNowBanner({ text, isCloseHidden = true, onClose }: Props) {
  function onBuyNowClick() {
    window.open("https://apps.appf.re/mcpp/marketplace", "blank", "noreferrer,noopener");
  }

  function onAlertBannerClose() {
    onClose?.();
  }

  return (
    // TODO: fix this incorrect usage of AlertBanner
    <AlertBanner isCloseHidden={isCloseHidden} onClose={onAlertBannerClose}>
      <AlertBannerText data-testid="license-banner-message" text={text} />
      <AlertBannerText text=" " />
      <AlertBannerButton onClick={onBuyNowClick}>Buy now</AlertBannerButton>
    </AlertBanner>
  );
}
